// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"chartWrapper--+S2NK","title":"title--ls+pY","legend":"legend--e2Zjg","tooltip":"tooltip--N5O7g","colorBox":"colorBox--OpGZb"};